// Presentation-only colour mapping for the RunTabs status dot + record-bar
// status pill (BRAND-9515 Idea-2 rework). Deliberately separate from
// sourcingRunStatusLabel (the protected i18n contract, unchanged) — this
// module never renders text, only a colour, so an unrecognised status safely
// falls back to a neutral tone instead of throwing (same D1 unknown-tolerant
// convention as the label mapper).
const STATUS_TONE: Record<string, string> = {
  importing: '#00b9d5',
  ready_for_vibe_check: '#01d36d',
  vibe_check_completed: '#4d4d4d',
  failed: '#fc5151',
  expired: '#b3b3b3',
}

const FALLBACK_TONE = STATUS_TONE.expired

// BRAND-9582: substitute tone for a run that completed but sourced nobody
// (utils/sourcingRunEmptyResult) — its raw `ready_for_vibe_check` tone reads
// as "work waiting for you", which is misleading over an empty list.
export const NEUTRAL_TONE = STATUS_TONE.expired

export const sourcingRunStatusTone = (status: string): string =>
  STATUS_TONE[status] ?? FALLBACK_TONE
